module.exports = __webpack_public_path__ + "static/media/menuMore.46cf66d2.svg";